export default {
    getEmpresa: state => state.empresa,
    getUsuarios: state => state.usuarios,
    getPermissoes: state => state.permissoes,
    getGrupos: state => state.grupos
}



// WEBPACK FOOTER //
// ./src/store/modules/usuario/getters.js